import type { ReportData } from "../report-data/index.js";

export function toTitle(result: ReportData): string {
  return result.report.title || result.reteyner.name + " report";
}
